<template>
  <div :style="{ height: top > 0 ? 10900+offset*2+'px' : 'auto' }">
    <div class="bg">
      <div class="row">
        <p class="ft80 t-left my4">BEST IN MILLION</p>
        <p class="ft80 t-right my4">LIGHT OF SCIENCE</p>
        <p class="ft18 t-center line-height35">
          亿优认为科技应该闪烁人性的光辉，我们甚至认为砍伐森林是不对的，所以我们创造了硅基芯材，每一块硅基板的
          诞生都将拯救一棵树，在黑暗中思考世界，将亿优的思想照耀人类。
        </p>
        <p class="ft14 t-center"><span class="pointer" @click='showDialog(100)'>查看更多</span></p>
      </div>
      <canvas id="mycanvas"></canvas>
    </div>
    <div
      class="scrollFix"
      :style="{
        position: top > 0 && top < 7000 ? 'fixed' : 'relative',
        top: top > 0 && top < 7000 ? '-500px' : top > 6900 ? '6770px' : '',
      }"
    >
      <div class="materials">
        <div class="row flex vcenter">
          <div class="text">
            <div class="flex vcenter flex-column ">
              <p class="ft45">GUIJI Polymer Materials</p>
              <p class="ft18">
                自主研发的硅基混合免烧结晶技术加工而成，高分子环保材料
                广泛应用于各种场景，提供装配式解决方案，性能卓越。
              </p>
              <div class="flex my6 full">
                <div class="button-black pointer mr4"  @click='showDialog(101)'>立刻联系</div>
                <div class="button-plain pointer " @click="$router.push('/product')">了解更多</div>
              </div>
            </div>
          </div>
          <img class="img" :src="require('../assets/index/1.png')" />
        </div>
      </div>
      <div class="impossible">
        <div class="row flex vcenter hcenter">
          <div class="text">
            <div class="flex hcenter flex-column ">
              <p class="ft50 my2">伟大的高分子，让不可能 成为可能</p>
              <transition name="fade">
                <div v-if='top<2100' class='scrollText'>
                  <p class="ft24 my2 full">燃烧性能，可达A1级</p>
                  <p class="ft18 my2">
                    可耐1200℃的高温，耐火极限最高可达4小时，真正做到防火
                    不燃，消防安全有保障。
                  </p>
                </div>
              </transition>
              <transition name="fade">
                <div v-if='top>=2100&&top<=4100' class='scrollText' >
                  <p class="ft24 my2 full">超极耐水，超乎想象</p>
                  <p class="ft18 my2">
                    浸水后的强度反而升高，弹性模量≥1100MPa，超级坚韧 不变形
                    吸水厚度膨胀率≤10%。
                  </p>
                </div>
              </transition>
                <div v-if='top>4100' class='scrollText'>
                  <p class="ft24 my2 full">坚硬无比，取自天然</p>
                  <p class="ft18 my2">
                    主要以硅藻泥、硅灰石、增强纤维、三氧化二铝、导电云母、膨
                    胀珍珠岩等原料作为骨料。
                  </p>
                </div>
              
              <!-- <p class="ft24 my2 full">燃烧性能，可达A1级</p>
                <p class="ft18 my2">
                  可耐1200℃的高温，耐火极限最高可达4小时，真正做到防火
                  不燃，消防安全有保障。
              </p> -->
              
              
            </div>
          </div>

          <canvas id="02-head-bob-turn" width="500" height="500"></canvas>
        </div>
      </div>
      <div class="eyo">
        <div class="row">
          <p class="ft45 my2">Eyo OS 让你的想法自由应用</p>
          <p class="ft18 my2">
            以现有新型装配式建筑装饰材料为支撑，逐步构建“以装配式建筑＋装配式装修的闭环生态圈”。
            广泛应用于各种场景，提供装配式解决方案，性能卓越。
          </p>
          <img class="img pointer" :src="require('../assets/index/EyoOs.gif')" @click="$router.push('/solve')"/>
        </div>
      </div>
      <div class="industry">
      <div class="row">
        <p class="ft45 my2">产业布局</p>
        <p class="ft18 my2">
          致力成为新材料领域拥有科技创新力及品牌影响的智能制造龙头企业
        </p>
        <div class="layout">
          <div class="info-color ft50 t-center">PRODUCT LAYOUT</div>
          <div class="flex justify-spaceBetween vcenter my8">
            <div class="item pointer">
              <img class="img" :src="require('../assets/index/industry1.jpg')" />
              <p class="t-center">多功能防火装饰材料</p>
            </div>
            <div class="item pointer">
              <img class="img" :src="require('../assets/index/industry2.jpg')" />
              <p class="t-center">装配式室内空间装饰材料</p>
            </div>
            <div class="item pointer">
              <img class="img" :src="require('../assets/index/industry3.jpg')" />
              <p class="t-center">建筑防火节能新材料</p>
            </div>
            <div class="item pointer">
              <img class="img" :src="require('../assets/index/industry4.jpg')" />
              <p class="t-center">节能装饰集成材料</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    
    <!-- <open-dialog ref='bgDialog' :newsId='100' />
    <open-dialog ref='concatDialog' :newsId='101' />
    <open-dialog ref='learnMoreDialog' :newsId='102' /> -->
  </div>
</template>

<script>
import {
  Canvas,
  Pointer,
  WebGL,
} from "@/utils/canvas";
import openDialog from '../components/openDialog.vue';

export default {
  components: { openDialog },
  name: "Index",
  mounted() {
    this.draw();
    this.init();
    this.offset = document.documentElement.clientHeight - 45 - 892;
    window.addEventListener("scroll", this.handleScrollx, true);
  },
  //离开页面时销毁
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollx);
  },
  data() {
    return {
      top: 0,
      scrollImg: require("../assets/index/A (1).png"),
      offset:0,//非1080高度下由于bg必须占满首屏导致在不同屏幕高度下滚动高度不同，添加offset予以修正
    };
  },
  methods: {
    draw() {
      ((struct) => {
        // Node class
        class Node {
          constructor(node) {
            this.pos = gl.vec3(node.x, node.y, node.z);
            this.old = gl.vec3(node.x, node.y, node.z);
            this.radius = node.w;
            this.mass = node.mass || 1.0;
            this.rgb = gl.vec3(node.color[0], node.color[1], node.color[2]);
          }
          // verlet integration
          integrate() {
            const [x, y, z] = this.pos.get();
            this.pos.x += this.pos.x - this.old.x;
            this.pos.y += this.pos.y - this.old.y - 0.001 * this.mass;
            this.pos.z += this.pos.z - this.old.z;
            this.old.set(x, y, z);
          }
          // draw node
          draw(shader) {
            shader
              .vec3("modelColor", this.rgb.x, this.rgb.y, this.rgb.z)
              .mat4(
                "model",
                gl
                  .mat4()
                  .trans(this.pos.x, this.pos.y, this.pos.z)
                  .scale(this.radius, this.radius, this.radius)
              )
              .draw(sphereGeom);
          }
          checkScreenLimits() {
            // ground (water?)
            if (this.pos.y <= -1 + this.radius * 0.2) {
              this.pos.x -= (this.pos.x - this.old.x) * 0.02;
              this.pos.z -= (this.pos.z - this.old.z) * 0.02;
              const d = Math.abs(-1 - this.pos.y + this.radius * 0.2);
              this.pos.y += d / 10;
              this.old.y = this.pos.y;
            }
          }
        }
        // constraint class
        class Constraint {
          constructor(n0, n1, size) {
            this.n0 = n0;
            this.n1 = n1;
            this.size = size || 0;
            this.dist = n0.pos.distance(n1.pos);
          }
          // solve constraint
          solve() {
            const n0 = this.n0.pos;
            const n1 = this.n1.pos;
            let dx = n0.x - n1.x;
            let dy = n0.y - n1.y;
            let dz = n0.z - n1.z;
            const currentDist = Math.sqrt(dx * dx + dy * dy + dz * dz);
            const delta = (0.5 * (currentDist - this.dist)) / currentDist;
            dx *= delta;
            dy *= delta;
            dz *= delta;
            let m1 = this.n0.mass + this.n1.mass;
            let m2 = this.n0.mass / m1;
            m1 = this.n1.mass / m1;
            n1.x += dx * m2;
            n1.y += dy * m2;
            n1.z += dz * m2;
            n0.x -= dx * m1;
            n0.y -= dy * m1;
            n0.z -= dz * m1;
          }
          draw(shader) {
            if (!this.size) return;
            const dx = this.n1.pos.x - this.n0.pos.x;
            const dy = this.n1.pos.y - this.n0.pos.y;
            const dz = this.n1.pos.z - this.n0.pos.z;
            const ln = Math.sqrt(dx * dx + dy * dy + dz * dz);
            const a = (-Math.atan2(dy, dz) * 180) / Math.PI;
            const b = (Math.asin(dx / ln) * 180) / Math.PI;

            shader
              .vec3("modelColor", 1, 1, 1)
              .mat4(
                "model",
                gl
                  .mat4()
                  .trans(this.n0.pos.x, this.n0.pos.y, this.n0.pos.z)
                  .rotatex(a)
                  .rotatey(b)
                  .trans(0, 0, ln * 0.5)
                  .scale(this.size, this.size, ln * 0.5)
              )
              .draw(tubeGeom);
          }
        }
        // animation loop
        const run = () => {
          requestAnimationFrame(run);
          // integration
          for (let n of nodes) {
            n.integrate();
            n.checkScreenLimits();
          }
          // solve constraints
          for (let i = 0; i < 5; i++) {
            for (let n of constraints) {
              n.solve();
            }
          }
          // webGL rendering
          gl.adjustSize()
            .viewport()
            .cullFace()
            .clearColor(0, 0, 0, 0)
            .clearDepth(1);
          // camera
          camProj.perspective({
            fov: 60,
            aspect: gl.aspect,
            near: 0.01,
            far: 100,
          });
          pointer.z = Math.min(Math.max(pointer.z, 3), 21);
          camDist += 0.1 * (pointer.z / 3 - camDist);
          camView.ident().trans(0, 0, -camDist);
          // light position
          const light = nodes[4].pos;
          // set uniforms
          displayShader
            .use()
            .vec3("uPointLightingLocation", light.x, light.y + 0.06, light.z)
            .vec3("uPointLightingColor", 1.0, 1.0, 1.0)
            .mat4("camProj", camProj)
            .mat4("camView", camView);
          // draw ground
          displayShader
            .vec3("modelColor", 0.6, 1.0, 1.2)
            .mat4("model", gl.mat4().trans(0.0, -1.0, 0.0))
            .draw(planeGeom);
          // draw nodes
          for (let n of nodes) {
            n.draw(displayShader);
          }
          // draw constraints
          for (let c of constraints) {
            c.draw(displayShader);
          }
          // manage pointer
          if (pointer.isDown) {
            if (!drag) {
              // determine which sphere is under the pointer ?
              let dmax = 10000,
                over = null;
              viewProj.multiply(camProj, camView);
              for (let n of nodes) {
                point.transformMat4(n.pos, viewProj);
                let x = Math.round(((point.x + 1) / 2.0) * canvas.width);
                let y = Math.round(((1 - point.y) / 2.0) * canvas.height);
                let dx = Math.abs(pointer.x - x);
                let dy = Math.abs(pointer.y - y);
                let d = Math.sqrt(dx * dx + dy * dy);
                if (d < dmax) {
                  dmax = d;
                  over = n;
                }
              }
              canvas.elem.style.cursor = "move";
              drag = over;
              rgb.copy(drag.rgb);
              if (drag.radius !== 0.1) drag.rgb.set(2, 1, 0);
            }
            // dragging
            let x =
              ((2.0 * pointer.x) / canvas.width - 1) *
              0.55 *
              camDist *
              gl.aspect;
            let y = ((-2.0 * pointer.y) / canvas.height + 1) * 0.55 * camDist;
            drag.pos.x += (x - drag.pos.x) * 0.2;
            drag.pos.y += (y - drag.pos.y) * 0.2;
            drag.pos.z *= 0.99;
            drag.old.copy(drag.pos);
          } else {
            // stop dragging
            if (drag) {
              canvas.elem.style.cursor = "pointer";
              drag.rgb.copy(rgb);
              drag = null;
            }
          }
        };
        /**
         * Init script
         */
        const canvas = new Canvas("mycanvas");
        const gl = new WebGL(canvas).depthTest();
        const pointer = new Pointer(canvas);
        const point = gl.vec3();
        const camProj = gl.mat4();
        const camView = gl.mat4();
        const viewProj = gl.mat4();
        const planeGeom = gl.drawable(gl.plane(60));
        const sphereGeom = gl.drawable(gl.sphere(1, 36));
        const tubeGeom = gl.drawable(gl.cylinder(1, 36));
        const nodes = [];
        const constraints = [];
        let drag = null;
        let rgb = gl.vec3();
        let camDist = 3;
        pointer.z = camDist * 3;

        const displayShader = gl.shader({
          vertex: `
            uniform mat4 camProj, camView;
            uniform mat4 model;
            attribute vec3 position, normal;
            varying vec3 vLigthPosition;
            varying vec3 vNormal;
            void main(){
              vec4 vWorldPosition = model * vec4(position, 1.0);
              gl_Position = camProj * camView * vWorldPosition;
              vLigthPosition = vWorldPosition.xyz;
              vNormal = normal;
            }
          `,
          fragment: `
            uniform vec3 modelColor;
            uniform vec3 uPointLightingLocation;
            uniform vec3 uPointLightingColor;
            varying vec3 vLigthPosition;
            varying vec3 vNormal;
            void main(){
              vec3 lightDirection = normalize(uPointLightingLocation - vLigthPosition);
              float angle = max(dot(lightDirection, vNormal), 0.001);
              vec3 diffuse = pow(uPointLightingColor * angle * modelColor, vec3(1.0));
              gl_FragColor = vec4(diffuse, 1.0);
            }
          `,
        });

        // load nodes
        for (let n in struct.nodes) {
          const node = new Node(struct.nodes[n]);
          struct.nodes[n].id = node;
          nodes.push(node);
        }
        // define constraints
        for (let i = 0; i < struct.constraints.length; i++) {
          constraints.push(
            new Constraint(
              struct.nodes[struct.constraints[i][0]].id,
              struct.nodes[struct.constraints[i][1]].id,
              struct.constraints[i][2]
            )
          );
        }
        nodes[3].pos.x += 0.01;
        nodes[3].pos.z += 0.01;
        run();
      })({
        nodes: {
          n0: {
            x: -0.3,
            y: 1,
            z: -0.57735,
            w: 0.2,
            mass: 1.0,
            color: [1.5, 1.2, 0.8],
          },
          n1: {
            x: 0.2,
            y: 1,
            z: 0.288675,
            w: 0.2,
            mass: 1.0,
            color: [1.5, 1.2, 0.8],
          },
          n2: {
            x: -0.8,
            y: 1,
            z: 0.288675,
            w: 0.2,
            mass: 1.0,
            color: [1.5, 1.2, 0.8],
          },
          n3: {
            x: -0.3,
            y: 1.7,
            z: 0,
            w: 0.2,
            mass: 1.0,
            color: [0.8, 1.2, 1.5],
          },
          // light
          n4: {
            x: -0.3,
            y: 1.2,
            z: 0,
            w: 0.1,
            mass: 0.6,
            color: [1000.0, 1000.0, 1000.0],
          },
        },
        constraints: [
          ["n0", "n1", 0.01],
          ["n1", "n2", 0.01],
          ["n2", "n0", 0.01],
          ["n0", "n3", 0.01],
          ["n1", "n3", 0.01],
          ["n2", "n3", 0.01],
          ["n3", "n4"],
        ],
      });
    },
    handleScrollx() {
      if (window.pageYOffset > (1400+this.offset)) {
        this.top = window.pageYOffset - (1400+this.offset);
        if(window.pageYOffset>(8100+this.offset)){
          this.top = window.pageYOffset - (1200+this.offset);
        }
      } else {
        this.top = 0;
      }
    },
    init() {
      this.initData();
      this.initImages();
      //this.handleResize();
      this.bindEvents();
    },
    initData() {
      this.canvas2 = document.getElementById("02-head-bob-turn");
      this.context = this.canvas2.getContext("2d");
      this.MAX_LEN = 105;
      this.imgs = [];
      this.start = 1;
      this.oldStart = -1;
      this.addN = 1;
      this.interval = 60; // 控制刷新率
      this.leftY = 0;
      this.curScrollY = this.getScrollTop();
      this.startPos = this.curScrollY;
      this.lastPos = this.curScrollY;
      this.isStop = false;
    },

    initImages() {
      for (let i = 1; i <= this.MAX_LEN; i++) {
        const img = new Image();
        // img.onload = () => this.imgs[i] = img
        if (i <= 35) {
          img.src = this.getImage("A", i);
        } else if (i <= 70) {
          img.src = this.getImage("B", i - 35);
        } else {
          img.src = this.getImage("C", i - 70);
        }

        // 不管加载否 保证顺序
        this.imgs.push(img);
      }
    },

    bindEvents() {
      //window.addEventListener("resize", () => this.handleResize());
      window.addEventListener("scroll", () => this.handleScroll());
    },

    getScrollTop() {
      return window.scrollY || 0;
    },

    getImage(word, num) {
      // const t = "A ("+ num+")";

      return require("../assets/index/" + word + " (" + num + ").png");
    },

    isOver() {
      return this.start < 0 || this.start > this.MAX_LEN - 1;
    },

    handleScroll() {
      const scrollY = this.getScrollTop() - 1400;
      let delta = scrollY - this.curScrollY;
      const isDown = delta > 0;

      delta = Math.abs(delta) + this.leftY;
      this.curScrollY = scrollY;

      if (
        this.isStop &&
        isDown === this.needDown &&
        ((isDown && this.curScrollY > this.lastPos) ||
          (!isDown && this.curScrollY < this.lastPos))
      ) {
        this.isStop = false;
      }
      if (this.isStop) return;

      // good idea: 补偿
      const alpha = Math.floor(delta / this.interval) * this.addN || 0;
      this.leftY = delta % this.interval;

      isDown ? (this.start += alpha) : (this.start -= alpha);
      if (this.isOver() && !this.isStop) {
        // this.lastPos = scrollY
        this.isStop = true;

        // TODO: 多个 canvas 用 opacity 切换
        // this.canvas2.style.cssText = `opacity: 0;`
      }

      if (this.start < 0) this.start = 0;
      if (this.start > this.MAX_LEN - 1) this.start = this.MAX_LEN - 1;
      if (this.startPos >= scrollY) this.start = 0;
      if (this.oldStart === this.start) return;
      this.oldStart = this.start;
      // good idea：记录
      this.lastPos = scrollY;
      this.needDown = !isDown;
      if (scrollY > 7000) {
        return;
      }
      this.drawCanvas(this.start);
    },

    handleResize() {
      const wScale = window.innerWidth / (this.canvas2.width || 500);
      const hScale = (window.innerHeight - 52) / (this.canvas2.height || 500);

      this.canvas2.style.transform = `matrix(${wScale}, 0, 0, ${hScale}, 0, 0)`;
    },

    drawCanvas(sequence) {
      // 当前序列帧
      const imgTemp = this.imgs[sequence];
      const canvas = this.canvas2;
      canvas.width = 500;
      canvas.height = 500;
      imgTemp &&
      this.context.drawImage(imgTemp, 0, 0, canvas.width, canvas.height);
    },
  },
};
</script>

<style lang="scss" scoped>
.line-height35 {
  line-height: 35px;
}
*{
  user-select: none;
}
.bg {
  position: relative;
  width: 100%;
  height: calc(100vh - 45px);
  min-height:892px;
  .row {
    width: 900px;
    height: 362px;
    margin: 6% auto 0 auto;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    color: white;
    position: absolute;
    z-index: 2;
  }
  #mycanvas {
    position: absolute;
    width: 100%;
    height: calc(100vh - 45px);
    background: #000;
    cursor: pointer;
    position: absolute;
  }
}
.materials {
  .row {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    .text {
      width: 360px;
      position: relative;
      left: 160px;
    }
    .button-black{
      border-radius: 30px;
      padding:8px 20px;
      background-color: black;
      border:1px solid black;
      color:white;
      &:hover{
        background-color: rgba($color: #000000, $alpha: 0.7);
        border:1px solid rgba($color: #000000, $alpha: 0.7);
      }
    }
    .button-plain{
      border-radius: 30px;
      padding:8px 20px;
      border:1px solid black;
      &:hover{
        color: rgba($color: black, $alpha: 0.7);
        border:1px solid rgba($color: #000000, $alpha: 0.7);
      }
    }
  }
  .img {
    width: 980px;
    position: relative;
    left: 160px;
    top: 50px;
  }
}
.impossible {
  height: 100vh;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  .row {
    width: 1200px;
    margin: 0 auto;
    .text {
      width: 740px;
    }
    .ft50 {
      width: 570px;
      line-height: 65px;
      bottom:50px;
      position: relative;
    }
    .ft18 {
      width: 500px;
      line-height: 25px;
    }
    div{
      position: relative;
      .scrollText{
        position: absolute;
        top:110px;
      }
    }
  }
  .img {
    width: 500px;
    position: relative;
    left: -270px;
    top: -10px;
  }
}
.eyo {
  padding: 100px 0;
  .row {
    width: 1200px;
    margin: 0 auto;
    .ft18 {
      line-height: 32px;
      width: 783px;
    }
    img {
      width: 1200px;
    }
  }
}
.industry {
  background-color: #f8f8f8;
  padding: 100px 0;
  .row {
    width: 1200px;
    margin: 0 auto;
    .ft18 {
      line-height: 32px;
      width: 783px;
    }
    .layout {
      width: 1200px;
      margin-top: 100px;
      .flex {
        .item {
          .img {
            width: 280px;
            height: 200px;
            border-radius: 30px;
          }
        }
      }
    }
  }
}
.scrollFix {
  // top:-258px;
  width: 100%;
  background-color: white;
  z-index: 999;
  transition: all 0;
}
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
